<template>
  <!-- D: 컨텐츠 탭 : 출고현황 -->
  <div class="sheet-area shipment-status-sheet">
    <!-- D : 검색조건선택 -->
    <!-- D: pc 전용 -->
    <div class="c-filter-box">
      <div class="c-form-field only-pc">
        <label class="c-input-calender">
          <input
            type="text"
            title="시작일"
            readonly
            required
            data-datepicker
            ref="wadatIstStRef"
            id="wadatIstSt"
            v-model="data.biz1.search.searchDateSt"
          />
        </label>
        <span class="tilde">~</span>
        <label class="c-input-calender">
          <input
            type="text"
            title="종료일"
            readonly
            required
            data-datepicker
            ref="wadatIstEdRef"
            id="wadatIstEd"
            v-model="data.biz1.search.searchDateEd"
          />
        </label>
      </div>
      <div class="c-round-button-box">
        <div
          class="c-radio-round type-black"
          v-for="(item, index) in searchPeriod"
          :key="index"
        >
          <input
            type="radio"
            :id="'filter-date-option3-' + index"
            name="filter-date-option3"
            :value="item.value"
            v-model="data.biz1.search.searchPeriod"
            @change="dateCalculation(item.value)"
          />
          <label :for="'filter-date-option3-' + index">{{ item.name }}</label>
        </div>
      </div>
      <!-- // D: pc 전용 -->
      <!-- D: mo 전용 -->
      <div class="c-form-field only-mo">
        <button
          type="button"
          class="btn-date-select"
          @click="btnCmd('biz1#searchPopup')"
        >
          <span> {{ data.biz1.resDateSt }} ~ {{ data.biz1.resDateEd }} </span>
        </button>
      </div>
      <!-- // D: mo 전용 -->
      <div class="c-filter-search">
        <form
          class="search-form"
          @submit.prevent
          @click="btnCmd('biz1#searchPopup')"
        >
          <label class="sr-only">주문검색</label>
          <input
            type="search"
            id="searchQuery"
            title="검색"
            class="search-input"
            autocomplete="off"
            placeholder="제품명/제품코드/배송지/인수자 입력"
            v-model="data.biz1.search.searchQuery"
          />
          <button
            type="button"
            class="search-cancel"
            @click="data.biz1.search.searchQuery = ''"
          >
            <i class="c-icon icon-large-x"></i>
            <span class="sr-only">검색어 재입력</span>
          </button>
          <button
            type="submit"
            class="search-submit"
            @click="searchCmd('biz1#search')"
          >
            <span class="sr-only">검색</span>
          </button>
        </form>
      </div>

      <div class="c-btn-area">
        <button
          type="button"
          class="c-util-button type-line-black"
          @click="resetCmd('biz1#reset')"
        >
          <span>초기화</span>
        </button>
        <button
          type="button"
          class="c-util-button type-primary"
          @click="searchCmd('biz1#search')"
        >
          <span>조회</span>
        </button>
      </div>
    </div>
    <!-- // D : 검색조건선택 -->

    <!-- D : 주문서 영역 -->
    <div class="c-table-util-box">
      <div class="c-table-top-util">
        <div class="left-box">
          <div class="text-item">
            <strong> 조회결과 : </strong>
            <span>
              {{ data.biz1.totalCount }}건 ({{ data.biz1.totalSum }})
            </span>
          </div>
          <div class="text-item type-regular">
            <strong> 출고완료기준 : </strong>
            <template v-if="data.biz1.resDateSt && data.biz1.resDateEd">
              <span>
                {{ data.biz1.resDateSt }} ~
                {{ data.biz1.resDateEd }}
              </span>
            </template>
          </div>
        </div>
        <div class="right-box">
          <p class="info-txt only-pc" v-if="data.biz1.list.length > 0">
            설정된 기간에 대한 조회 결과가 다운로드 됩니다.
          </p>
          <button
            v-if="data.biz1.list.length > 0"
            type="button"
            class="c-util-button type-line-black"
            @click="btnCmd('biz1#excelDownload')"
            style="float: right"
          >
            <i class="c-icon icon-xlsx size-medium"></i>
            <span>다운로드</span>
          </button>
        </div>
      </div>
      <!-- D: pc 전용 -->
      <template v-if="data.biz1.list && data.biz1.list.length > 0">
        <div class="scroll-x only-pc">
          <div class="scroll-x-inner">
            <div class="c-table type-small">
              <table>
                <caption>
                  출고현황 테이블
                </caption>
                <colgroup>
                  <col style="width: 60px" />
                  <col style="width: 100px" />
                  <col style="width: 100px" />
                  <col style="width: 100px" />
                  <col style="width: 150px" />
                  <col style="width: 140px" />
                  <col style="width: 130px" />
                  <col style="width: 130px" />
                  <col style="width: 180px" />
                  <col style="width: 60px" />
                  <col style="width: 90px" />
                  <col style="width: 90px" />
                  <col style="width: 90px" />
                  <col style="width: 110px" />
                  <col style="width: 120px" />
                  <col style="width: 130px" />
                  <col style="width: 100px" />
                  <col style="width: 130px" />
                  <col style="width: 110px" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">NO</th>
                    <th scope="col">출고일자</th>
                    <th scope="col">배송<br />완료일자</th>
                    <th scope="col">주문일자</th>
                    <th scope="col">
                      페인트 프로 <br />
                      주문번호
                    </th>
                    <th scope="col">
                      SAP <br />
                      주문번호
                    </th>
                    <th scope="col">
                      납품 <br />
                      문서번호
                    </th>
                    <th scope="col">제품코드</th>
                    <th scope="col">제품명</th>
                    <th scope="col">규격</th>
                    <th scope="col">주문수량</th>
                    <th scope="col">출고수량</th>
                    <th scope="col">취소수량</th>
                    <th scope="col">출고지</th>
                    <th scope="col">배송지</th>
                    <th scope="col">인수자</th>
                    <th scope="col">인수자 연락처</th>
                    <th scope="col">배송방법</th>
                    <th scope="col">운전기사 연락처</th>
                    <th scope="col">차량번호</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="data.biz1.list.length > 0">
                    <ShipmentListContRow
                      v-for="(item, index) in data.biz1.list"
                      :key="item.rkey"
                      :index="index"
                      :item="item"
                    />
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
      <!-- // D: pc 전용 -->
      <!-- D: mo 전용 -->
      <div class="mo-order-result-area">
        <p class="info-txt" v-if="data.biz1.list.length > 0">
          설정된 기간에 대한 조회 결과가 다운로드 됩니다.
        </p>
        <ul class="result-list">
          <template v-if="data.biz1.list && data.biz1.list.length > 0">
            <MoShipmentListContRow
              v-for="(item, index) in data.biz1.list"
              :key="item.rkey"
              :index="index"
              :item="item"
              @detail="(item) => btnCmd('biz1#moDetail', item)"
            />
          </template>
        </ul>
      </div>
      <!-- // D: mo 전용 -->

      <!-- D: no data -->
      <template v-if="data.biz1.hasNoData && data.biz1.list.length < 1">
        <div class="c-no-data-box">
          <div class="icon-box">
            <i class="c-icon icon-nodata size-large"></i>
          </div>
          <p class="text">
            기간 내 조회 결과가 없습니다. <br />
            조회 조건을 다시 입력해주세요.
          </p>
        </div>
      </template>
    </div>
    <!-- // D : 주문서 영역 -->

    <!-- D : pageing area -->
    <template v-if="data.biz1.list && data.biz1.list.length > 0">
      <Pagination
        ref="paginationEl"
        :total-pages="data.biz1.totalPage"
        :per-page="data.biz1.limit"
        :show-select="true"
        @page-change="handlePageChange_biz1"
        @items-per-page-change="handleItemsPerPageChange_biz1"
      />
    </template>
    <!-- // D : pageing area -->
  </div>
  <!-- // D: 컨텐츠 탭 : 출고현황 -->

  <!-- MO 상세조회 팝업 -->
  <MoDeepInqueryPop
    v-if="data.popup.showInqueryPopup"
    :filter="data.biz1.search"
    :div="data.page.div"
    @search="(param) => btnCmd('biz1#moSearch', { search: param })"
    @close="data.popup.showInqueryPopup = false"
  />

  <!-- MO 출고현황 상세보기 팝업 -->
  <MoShipmentListDetail
    v-if="data.popup.showMoDetailPopup"
    :item="data.biz1.moItem"
    @close="() => (data.popup.showMoDetailPopup = false)"
  />
</template>
<script setup name="chipmentListCont">
import {
  onMounted,
  ref,
  reactive,
  inject,
  computed,
  onBeforeUnmount,
  watch,
} from "vue";
import Pagination from "@/components/paintpro/base/pagination.vue";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();
import { api } from "@/plugins/api";
import $ from "jquery";
import MoDeepInqueryPop from "./moDeepInqueryPop.vue";
import { throttle } from "lodash";
import MoShipmentListContRow from "./moShipmentListContRow.vue";
import ShipmentListContRow from "./shipmentListContRow.vue";
import MoShipmentListDetail from "./moShipmentListDetail.vue";

const url = inject("url_prefix");
const wadatIstStRef = ref(null);
const wadatIstEdRef = ref(null);
const paginationEl = ref(null);
const searchPeriod = ref([
  { name: "당일", value: "today" },
  { name: "1개월", value: "month" },
  { name: "6개월", value: "half-year" },
  { name: "1년", value: "year" },
]);
const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    userLoginInfo: {},
    deviceType: isMobile.value ? "M" : "P",
    basketCount: {},
    breadcrumbItems: [],
    div: "shipmentList",
  },
  codes: {
    code01: [],
    code02: [],
  },
  popup: {
    showInqueryPopup: false,
  },
  biz1: {
    search: {
      searchDateSt: "", // 시작 출고일자
      searchDateEd: "", // 끝 출고일자
      searchQuery: "", // 검색어
      searchPeriod: "",
      useYn: "Y",
      orderBy: "",
    },
    resDateSt: "",
    resDateEd: "",
    search_init: {}, // 검색 파라메터 초기값
    list: [], // 목록
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    totalSum: 0,
    loading: false,
    hasNoData: false,
    moItem: {},
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함수
 *********************/
async function pageInit() {
  await pageInitData();
  searchCmd("biz1#search"); // biz1 데이타 조회
  jqueryDatepicker();
  // 스크롤 이벤트 등록
  if (data.page.deviceType == "M") {
    document.addEventListener("scroll", handleScroll);
  }
  store.useShipmentListStore().registerSearchFunction(showGraphData);
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return false;
  }

  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
  data.page.userLoginInfo = store.useAuthStore()?.user;

  data.biz1.search.searchPeriod = "month"; // 검색조건 기간 스타일 적용
  dateCalculation("month");

  // ◼◼◼ 초기데이타 백업
  data.biz1.search_init = { ...data.biz1.search };
}

/**********************
 * 리셋 모음
 *********************/
async function resetCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#reset") {
    // ◼◼◼ biz1 초기화
    data.biz1.search = { ...data.biz1.search_init };
    dateCalculation("month");
  } else {
    alert(`[개발확인] resetCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#search") {
    if (
      calculateDateDifference(
        data.biz1.search.searchDateSt,
        data.biz1.search.searchDateEd
      )
    ) {
      cmUtil.alert("조회기간은 최대 1년입니다.\n날짜를 다시 선택해주세요.");
      return;
    }
    const res = await api.get(`${url}/order/selectShipmentList`, {
      params: {
        ...data.biz1.search,
        page: parms["page"] || 1,
        limit: parms["limit"] || data.biz1.limit,
      },
    });
    if (parms["page"] == null || parms["page"] == 1) {
      paginationEl.value?.setCurrentPage(1);
    }
    data.biz1.list = res.data.pageResult.list;
    data.biz1.page = parms["page"] || 1;
    data.biz1.totalCount = res.data.pageResult.totalCount;
    data.biz1.totalPage = data.biz1.totalCount
      ? Math.ceil(data.biz1.totalCount / data.biz1.limit)
      : 0;
    data.biz1.totalSum = res.data.sum;
    data.biz1.resDateSt = data.biz1.search.searchDateSt;
    data.biz1.resDateEd = data.biz1.search.searchDateEd;
    if (data.biz1.list.length > 0) {
      data.biz1.hasNoData = false;
    } else {
      data.biz1.hasNoData = true;
    }
  } else if (cmd === "biz1#scroll") {
    if (
      calculateDateDifference(
        data.biz1.search.searchDateSt,
        data.biz1.search.searchDateEd
      )
    ) {
      cmUtil.alert("조회기간은 최대 1년입니다.\n날짜를 다시 선택해주세요.");
      return;
    }
    const res = await api.get(`${url}/order/selectShipmentList`, {
      params: {
        ...data.biz1.search,
        page: parms["page"] || 1,
        limit: parms["limit"] || data.biz1.limit,
      },
    });

    if (res.data.pageResult.list.length > 0) {
      data.biz1.list.push(...res.data.pageResult.list);
      data.biz1.page = parms["page"] || 1;
      data.biz1.totalCount = res.data.pageResult.totalCount;
      data.biz1.totalPage = data.biz1.totalCount
        ? Math.ceil(data.biz1.totalCount / data.biz1.limit)
        : 0;
      data.biz1.resDateSt = data.biz1.search.searchDateSt;
      data.biz1.resDateEd = data.biz1.search.searchDateEd;
      data.biz1.hasNoData = false;
    } else {
      data.biz1.hasNoData = true;
    }
  } else {
    alert(`[개발확인] searchCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

/**********************
 * 페이징 모음
 *********************/
function handlePageChange_biz1(page) {
  searchCmd("biz1#search", { page: page });
}
function handleItemsPerPageChange_biz1(perPage) {
  data.biz1.limit = perPage;
  searchCmd("biz1#search");
}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#excelDownload") {
    try {
      const response = await fetch(
        `${url}/order/shipmentExcelDownload?searchDateSt=${data.biz1.search.searchDateSt}&searchDateEd=${data.biz1.search.searchDateEd}&searchQuery=${data.biz1.search.searchQuery}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${cmUtil.getLocalStorage("token")}`,
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
        }
      );

      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `출고현황_${cmUtil.getToday("yyyyMMddHHmmss")}.xlsx`;
        link.click();
      } else {
        const errorMessage = await response.text();
        alert(`파일 다운로드 실패: ${errorMessage}`);
      }
    } catch (error) {
      alert(`네트워크 오류: ${error.message}`);
    }
  } else if (cmd === "biz1#searchPopup") {
    if (data.page.deviceType == "M") {
      data.popup.showInqueryPopup = true;
    }
  } else if (cmd === "biz1#moSearch") {
    data.biz1.search = { ...parms.search };
    data.popup.showInqueryPopup = false;
    searchCmd("biz1#search");
  } else if (cmd === "biz1#moDetail") {
    data.biz1.moItem = parms;
    data.popup.showMoDetailPopup = true;
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

// 그래프에서 클릭한 월로 리스트 검색
const showGraphData = (param) => {
  const [start, end] = getMonthStartEnd(param.year, param.month);
  data.biz1.search.searchDateSt = start;
  data.biz1.search.searchDateEd = end;
  data.biz1.search.searchPeriod = null;
  searchCmd("biz1#search");
};

const datePair = computed(() => [
  data.biz1.search.searchDateSt,
  data.biz1.search.searchDateEd,
]);

// 검색기간 시작일, 종료일 체크
watch(
  datePair,
  async ([newStartDate, newEndDate], [oldStartDate, oldEndDate]) => {
    const start = new Date(newStartDate);
    const end = new Date(newEndDate);
    if (end < start) {
      data.biz1.search.searchDateSt = oldStartDate;
      data.biz1.search.searchDateEd = oldEndDate;
      await cmUtil.alert(
        "종료일을 시작일보다 이전으로 설정할 수 없습니다.<br>다시 확인해주세요."
      );
    }
  }
);

// 검색 기간 계산
async function dateCalculation(period) {
  const today = new Date();
  let resultDate = new Date(today);
  switch (period) {
    case "today":
      resultDate.setDate(today.getDate());
      break;
    case "week":
      resultDate.setDate(today.getDate() - 6);
      break;
    case "month":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "half-year":
      resultDate.setDate(today.getDate() - 179);
      break;
    case "year":
      resultDate.setDate(today.getDate() - 364);
      break;
    default:
      await cmUtil.alert("알 수 없는 기간입니다.");
      return null;
  }

  // YYYY-MM-DD 형식으로 변환
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  resultDate = resultDate.toLocaleDateString("en-CA", options);
  data.biz1.search.searchDateSt = resultDate;
  data.biz1.search.searchDateEd = todayDate.value;
}

// jquery 달력
function jqueryDatepicker() {
  if (wadatIstStRef.value == null) return;
  $(wadatIstStRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: 0,
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.biz1.search.searchDateSt = dateText;
      data.biz1.search.searchPeriod = "all";
    },
  });
  if (wadatIstEdRef.value == null) return;
  $(wadatIstEdRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: 0,
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.biz1.search.searchDateEd = dateText;
      data.biz1.search.searchPeriod = "all";
    },
  });
}

// 날짜 차이를 계산하는 함수
function calculateDateDifference(start, end) {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const msInOneDay = 1000 * 60 * 60 * 24;
  const timeDifference = Math.abs(endDate - startDate);
  const dayDifference = timeDifference / msInOneDay;

  // 1년(365일) 이상의 차이가 있는지 확인
  return dayDifference >= 365;
}

// 클릭한 월의 기간을 구하는 함수
function getMonthStartEnd(year, month) {
  // 주어진 월의 첫 날 (첫째 날은 항상 1일)
  const startDate = new Date(year, month - 1, 1); // month는 0부터 시작하므로 -1
  const endDate = new Date(year, month, 0); // 해당 월의 마지막 날을 구하려면 다음 달의 0일로 설정

  const today = new Date();
  const currentYearMonth = `${today.getFullYear()}-${today.getMonth() + 1}`;

  // 주어진 년월이 오늘 날짜의 년월과 같으면 마지막 날짜를 오늘 날짜로 설정
  const endOfMonth = currentYearMonth === `${year}-${month}` ? today : endDate;

  // 날짜 포맷을 'YYYY-MM-DD' 형태로 반환
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return [formatDate(startDate), formatDate(endOfMonth)];
}

const handleScroll = throttle(() => {
  if (
    data.page.deviceType != "M" ||
    data.biz1.hasNoData ||
    data.biz1.loading ||
    data.biz1.list.length === 0
  ) {
    return;
  }
  data.biz1.loading = true;

  const scrollPosition = window.innerHeight + window.scrollY;
  const bottom = document.documentElement.scrollHeight;

  if (scrollPosition >= bottom - 350) {
    searchCmd("biz1#scroll", { page: data.biz1.page + 1 });
  }
  data.biz1.loading = false;
}, 300);

onBeforeUnmount(() => {
  document.removeEventListener("scroll", handleScroll);
});
</script>
